import React, { FunctionComponent, useState } from "react"
import { RunModelDto } from "@store/services/modelsService"
import { Collapse, Typography } from "@mui/material"
import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import { ExpandLess, ExpandMore } from "@mui/icons-material"
import CompareIcon from "@mui/icons-material/Compare"
import Grid from "@mui/material/Grid"
import { MRT_TableInstance, MaterialReactTable } from "material-react-table"
import { ModelAndRunMetadataCard } from "@features/run/viewModel/ModelAndRunMetadataCard"
import { getRunName } from "@utils/run"
import { RunDto } from "@custom-types/modelRun"

interface Props {
  runName: string | undefined
  table: MRT_TableInstance<RunDto>
  selectedRun: RunDto | undefined
  runModel: RunModelDto | undefined
  open?: boolean
}

export const ComparisonMetadataCard: FunctionComponent<Props> = ({
  table,
  selectedRun,
  runModel,
  runName,
  open = true,
}) => {
  const [isExpanded, setIsExpanded] = useState(open)

  const handleExpandCollapseClick = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <Card sx={{ width: "100%", mt: "30px", boxShadow: "none", borderRadius: "5px !important" }}>
      <CardContent
        sx={{
          paddingBottom: "5px !important",
          padding: "5px",
          mb: "0px",
          mt: "0px",
          cursor: "pointer",
          ":hover": { backgroundColor: "#f7f7f7" },
          borderBottom: "1px solid #e7e7e7",
        }}
        onClick={handleExpandCollapseClick}
      >
        {isExpanded ? (
          <ExpandMore sx={{ verticalAlign: "middle", marginTop: "-3px" }} />
        ) : (
          <ExpandLess sx={{ verticalAlign: "middle", marginTop: "-3px" }} />
        )}
        <CompareIcon sx={{ verticalAlign: "middle", marginTop: "-5px" }} />
        <Typography variant="h6" component="span" sx={{ ml: 1 }}>
          <b>{runName}</b>
        </Typography>
      </CardContent>
      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <CardContent
          sx={{
            paddingBottom: "5px !important",
            padding: "3px",
            mb: "0px",
            mt: "0px",
            cursor: "pointer",
            // borderBottom: "1px solid #e7e7e7",
          }}
        >
          <Grid container>
            <Grid item sx={{ maxHeight: "130px", padding: "4px", overflow: "scroll" }} xs={5}>
              <MaterialReactTable table={table} />
            </Grid>
            <Grid
              item
              sx={{ ml: "10px", maxHeight: "130px", padding: "4px", overflow: "scroll" }}
              xs
            >
              <ModelAndRunMetadataCard
                model={runModel}
                runName={"Metadata for " + getRunName(selectedRun) + " run"}
                samples={selectedRun?.num_samples || 0}
                seed={selectedRun?.seed || 0}
                simulationFrequency={String(selectedRun?.simulation_frequency || "")}
                version={selectedRun?.version}
                rungroup={selectedRun?.run_group_key}
                open={true}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Collapse>
    </Card>
  )
}
